import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiUserDetails } from '../../../../models/api.user.details.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../../services/app.service';
import { ApiUserDetailsService } from '../../../../services/api.user.details.service';

@Component({
  selector: 'app-api-user-details-edit-form',
  templateUrl: './api-user-details-edit-form.component.html',
  styleUrls: ['./api-user-details-edit-form.component.scss']
})
export class ApiUserDetailsEditFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  parent: any;
  apiUserDetailsId: number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  apiUserDetails = new ApiUserDetails();
  loadingIndicator = false;
  reorderable = true;
  translations: any;
  invalidForm = true;
  userInfo: any;

  currentTime: any = (new Date()).toLocaleString("nl-NL", { // you can use undefined as first argument
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { Id: 0, Parent: {} },
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    private apiUserDetailsService: ApiUserDetailsService,
    public dialogRef: MatDialogRef<ApiUserDetailsEditFormComponent>
  ) { 
    this.userInfo = JSON.parse(sessionStorage.pageList)[0];
    this.displayCurrentTime();
    this.formGroupErrors = {
      ApiUserName: {},
      ApiDescription: {},
      ApiIpAddresses: {},
      ApiKey: {}
    };
    this.formGroup = this.formBuilder.group({
      ApiUserName: ["", Validators.required],
      ApiDescription: ["", Validators.required],
      ApiIpAddresses: ["", Validators.required],
      ApiKey: [""],
      LastApiCallDateTime: ["", {disabled: true}]
    });
    this.parent = this.data.Parent;
    this.apiUserDetailsId = this.data.Id;
  }

  ngOnInit() {
    this.setPageTranslations();
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(      
        this.formGroup,
        this.formGroupErrors
      );
    });
    if (this.apiUserDetailsId > 0) {
      this.selectApiUserDetailsById();
    }
    else if(this.apiUserDetailsId === 0){
      this.apiUserDetails.ApiKey = this.parent.getGUID();
      this.appService.hideLoading();
    }
  }

  displayCurrentTime(){
    setInterval(() => {
      this.currentTime = (new Date()).toLocaleString("nl-NL", { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      })
    }, 1)
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  selectApiUserDetailsById(): void {
    this.apiUserDetailsService.select(this.apiUserDetailsId).subscribe(
        res => this.selectApiUserDetailsByIdSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  selectApiUserDetailsByIdSuccess(res): void {
    if (res.Data != null) {
      this.apiUserDetails = JSON.parse(res.Data)[0];
      if(this.apiUserDetails.LastApiCallDateTime != undefined){
        this.apiUserDetails.LastApiCallDateTime = new Date(this.apiUserDetails.LastApiCallDateTime.toString()).toLocaleString("nl-NL", { 
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      this.appService.hideLoading();
    } else {
      this.apiFaillure(res.Message);
    }
  }

  save(): void {
    this.apiUserDetailsService.save(JSON.stringify(this.apiUserDetails)).subscribe(
        res => this.saveApiUserDetailsSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  saveApiUserDetailsSuccess(res): void {
    if (res.Status == 1) {
      this.appService.showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
      ).afterClosed().subscribe(result => {
          if (result) {
            this.close();
          }
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  generateApiKey(){
    this.appService.showDialogue(this.translations.hdConfirm, this.translations.msgGenerateApiKeyConfirm, true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.apiUserDetails.ApiKey = this.parent.getGUID();
      }          
    });
  }

  close() {
    this.dialogRef.close();
  }

  apiFaillure(error): void {
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/api-user-details/api-user-details-edit-form/api-user-details-edit-form.component.ts